export default [
    {
        path: '/:organisation/ai/employees',
        component: () => import('@/pages/[organisation]/ai/employees.vue'),
        name: 'ai.ai-employees.search-ai-employees',
        meta: {
            loginRequired: true,
            permission: 'access.ai.employees.view-ai-employees'
        },
        children: [
            {
                path: 'create',
                component: () => import('@/pages/[organisation]/ai/employees/create.vue'),
                name: 'ai.ai-employees.create-ai-employee',
                meta: {
                    loginRequired: true,
                    permission: 'access.ai.employees.create-ai-employee'
                }
            },
            {
                path: ':id',
                component: () => import('@/pages/[organisation]/ai/ai-employees/ai-employees/[id].vue'),
                name: 'ai.ai-employees.view-ai-employee',
                meta: {
                    loginRequired: true,
                    permission: 'access.ai.employees.view-ai-employees'
                }
            }
        ]
    },
    {
        path: '/:organisation/ai/tasks',
        component: () => import('@/pages/[organisation]/ai/tasks.vue'),
        name: 'ai.ai-employees.search-ai-tasks',
        meta: {
            loginRequired: true,
            permission: 'access.ai.tasks.view-ai-tasks'
        },
        children: [
            {
                // `new` must come before `:id` so the dynamic route doesn't
                // capture the literal segment.
                path: 'new',
                component: () => import('@/pages/[organisation]/ai/tasks/new.vue'),
                name: 'ai.ai-employees.new-ai-task',
                meta: {
                    loginRequired: true,
                    permission: 'access.ai.tasks.create-ai-task'
                }
            },
            {
                path: ':id',
                component: () => import('@/pages/[organisation]/ai/tasks/[id].vue'),
                name: 'ai.ai-employees.view-ai-task',
                meta: {
                    loginRequired: true,
                    permission: 'access.ai.tasks.view-ai-tasks'
                }
            }
        ]
    },
];
